import { render, staticRenderFns } from "./UsersUpdateModal.vue?vue&type=template&id=2514b15a&"
import script from "./UsersUpdateModal.vue?vue&type=script&lang=js&"
export * from "./UsersUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports